import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService,
    private translate: TranslateService,
    private router: Router) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // console.log(err)
        if (err.status === 400) {
          Swal.fire({
            title: this.translate.instant('Alert!'),
            // text: this.translate.instant(error.error.message),
            text: this.translate.instant(err.error.message),
            // icon: 'info',
            confirmButtonColor: '#0e528b'
          })

        }
        else if (err.status === 404) {
          Swal.fire({
            title: this.translate.instant('Alert!'),
            // text: this.translate.instant(error.error.message),
            text: this.translate.instant(err.error.message),
            // icon: 'info',
            confirmButtonColor: '#0e528b'
          })
        } else if (err.status === 422) {
          Swal.fire({
            title: this.translate.instant('Alert!'),
            // text: this.translate.instant(error.error.message),
            text: this.translate.instant(err.error.message),
            // icon: 'info',
            confirmButtonColor: '#0e528b'
          })

        }  else if (err.status === 422) {
          Swal.fire({
            title: this.translate.instant('Alert!'),
            // text: this.translate.instant(error.error.message),
            text: this.translate.instant(err.error.message),
            // icon: 'info',
            confirmButtonColor: '#0e528b'
          })

        }else if (err.status == 500) {
          Swal.fire(
            'Connection Is Not Stable',
            'Please check your internet connection. It seems that it is not stable. <br>Detail:' + " " + err.message,
            'question'
          )
        } else if (err.status === 401) {
          //  Swal.fire(
          //   this.translate.instant('Alert!'),
          //   this.translate.instant(error.error.message),
          //   'info'
          // )
          Swal.fire({
            title: this.translate.instant('Unauthorized!'),
            // text: this.translate.instant(error.error.message),
            text: this.translate.instant("Please login again to continue."),
            icon: 'info',
            confirmButtonColor: '#0e528b'
          }).then(result => {
            localStorage.clear();
            this.router.navigate(['/authentication/signin']).then(() => {
              window.location.reload();
            });
          })
        } else {
          const error = err.error.message || err.statusText;
          return throwError(
            Swal.fire(
              'Connection Is Not Stable',
              'Please check your internet connection. It seems that it is not stable. <br>Detail:' + " " + error,
              'question'
            )
          );
        }

      })

    );
  }
}
